<template>
  <span>
    <span class="attribute-name">{{ name }}</span>
  </span>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    name: String,
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheet/_variables.scss";

.attribute-name {
  color: $attributeNameColor;
}
</style>
